import { motion } from 'framer-motion';
import EnrollmentVideoSection from './EnrollmentVideoSection';

const EnrollmentVideoTabs = () => {
  return (
    <>
      <motion.div
        className="text-center mg-bottom-48px"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
      >
        <div className="mg-bottom-8px">
          <div className="text-100 bold color-accent-1 text-uppercase">
            SIMPLIFY YOUR SETUP. GET VERIFIED FAST.
          </div>
        </div>
        <h2 className="display-2 color-neutral-100">Effortless Enrollment Process</h2>
        <p className="color-neutral-200">
          Getting your logo displayed in email clients with a blue checkmark is simpler than you
          think. <br />
          Our streamlined process makes it easy to get your brand verified and trusted.
        </p>
        <EnrollmentVideoSection />
      </motion.div>

      {/* <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
        className="enrollment-process-section"
      >
        <Typography.Title level={2} className="text-center">
          <span className="highlight-text">Effortless</span> Enrollment Process
        </Typography.Title>
        <Typography.Paragraph className="text-center enrollment-intro">
          Getting your logo displayed in email clients with a blue checkmark is simpler than you
          think. Our streamlined process makes it easy to get your brand verified and trusted.
        </Typography.Paragraph>
        
        <EnrollmentVideoSection />
      </motion.div> */}

      <style jsx>{`
        .enrollment-process-section {
          margin-bottom: 4rem;
          background: linear-gradient(
            180deg,
            rgba(247, 250, 255, 0.8) 0%,
            rgba(255, 255, 255, 0) 100%
          );
          padding: 4rem 0 3rem;
          border-radius: 24px;
          max-width: 1340px;
          margin-left: auto;
          margin-right: auto;
          position: relative;
          z-index: 1;
        }

        :global(.text-center) {
          text-align: center;
        }

        :global(.enrollment-intro) {
          max-width: 800px;
          margin: 0 auto 1.5rem;
          font-size: 18px;
          line-height: 1.6;
          color: #555;
        }

        :global(.highlight-text) {
          position: relative;
          color: #247bfe;
          z-index: 1;
        }

        :global(.highlight-text::after) {
          content: '';
          position: absolute;
          bottom: 0;
          left: -2px;
          right: -2px;
          height: 8px;
          background-color: rgba(36, 123, 254, 0.1);
          z-index: -1;
          border-radius: 4px;
        }

        @media (max-width: 767px) {
          .enrollment-process-section {
            padding: 3rem 1rem 2rem;
          }
        }
      `}</style>
    </>
  );
};

export default EnrollmentVideoTabs;
